export function getBrowserFingerPrint() {
    const info = {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenSize: `${window.screen.width}x${window.screen.height}`,
        windowSize: `${window.innerWidth}x${window.innerHeight}`,
        devicePixelRatio: window.devicePixelRatio,
        colorDepth: window.screen.colorDepth,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        touchPoints: navigator.maxTouchPoints,
        cookiesEnabled: navigator.cookieEnabled,
        timestamp: new Date().toISOString(),
        browserName: 'unknown'
    };

    // Also try to detect the specific browser name
    if (info.userAgent.indexOf('Firefox') > -1) info.browserName = 'Firefox';
    else if (info.userAgent.indexOf('SamsungBrowser') > -1) info.browserName = 'Samsung';
    else if (info.userAgent.indexOf('Opera') > -1 || info.userAgent.indexOf('OPR') > -1) info.browserName = 'Opera';
    else if (info.userAgent.indexOf('Trident') > -1) info.browserName = 'IE';
    else if (info.userAgent.indexOf('Edge') > -1) info.browserName = 'Edge';
    else if (info.userAgent.indexOf('Chrome') > -1) info.browserName = 'Chrome';
    else if (info.userAgent.indexOf('Safari') > -1) info.browserName = 'Safari';

    return (info)
}